import { render, staticRenderFns } from "./TgSpecialSlideBar.vue?vue&type=template&id=b376226c&"
import script from "./TgSpecialSlideBar.vue?vue&type=script&lang=js&"
export * from "./TgSpecialSlideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports